// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"094d9647","703":"40b5ba4c","787":"9f5d2f84"}[chunkId] + ".chunk.js";
};